import { getResolvedAsyncApiRef as e } from "@scalar/workspace-store/helpers/get-resolved-async-api-ref";
import { getAllChannelMessages as t, resolveOperationChannel as n, resolveOperationWithTraits as r } from "@scalar/workspace-store/channel-example";
import { getNameFromRef as i } from "@scalar/workspace-store/helpers/get-name-from-ref";
import { resolveTraits as a } from "@scalar/workspace-store/helpers/resolve-traits";
//#region src/code-example/helpers/get-asyncapi-example-context.ts
var o = (o, s) => {
	let c = e(o.operations?.[s]);
	if (!c) return;
	let l = r(c), u = n(o, l), d = u?.channel, f = (l.messages === void 0 ? d ? t(o, d) : [] : l.messages.flatMap((t, n) => {
		let r = e(t), a = t.$ref && u?.channelName ? i(t.$ref, [
			"channels",
			u.channelName,
			"messages"
		]) : void 0;
		return r && !("$ref" in r) ? [{
			name: a ?? t.$ref ?? String(n),
			message: r
		}] : [];
	})).map(({ name: e, message: t }) => ({
		name: e,
		message: a(t, t.traits ?? [])
	}));
	return {
		operation: l,
		channelName: u?.channelName,
		channel: d,
		messages: f
	};
};
//#endregion
export { o as getAsyncApiExampleContext };

//# sourceMappingURL=get-asyncapi-example-context.js.map